import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface TrendPoint {
  date: string;
  sent: number;
  opened: number;
}

/** Sent vs opened per day for the selected window (raw event counts). */
export function TrendChart({ data }: { data: TrendPoint[] }) {
  const label = (d: string) => d.slice(5); // MM-DD
  return (
    <div className="h-[220px] w-full" data-testid="trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -18 }}>
          <defs>
            <linearGradient id="ge-sent" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--ge-chart-1)" stopOpacity={0.35} />
              <stop offset="100%" stopColor="var(--ge-chart-1)" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="ge-opened" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--ge-accent)" stopOpacity={0.4} />
              <stop offset="100%" stopColor="var(--ge-accent)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="var(--ge-border-subtle)" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={label}
            tick={{ fill: "var(--ge-secondary)", fontSize: 10, fontFamily: "monospace" }}
            interval="preserveStartEnd"
            minTickGap={24}
            axisLine={{ stroke: "var(--ge-border-subtle)" }}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            width={34}
            tick={{ fill: "var(--ge-secondary)", fontSize: 10, fontFamily: "monospace" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              background: "var(--ge-card)",
              border: "1px solid var(--ge-border-card)",
              borderRadius: 8,
              fontSize: 12,
            }}
            labelStyle={{ color: "var(--ge-secondary)" }}
          />
          <Area type="monotone" dataKey="sent" name="Sent" stroke="var(--ge-chart-1)" strokeWidth={1.5} fill="url(#ge-sent)" />
          <Area type="monotone" dataKey="opened" name="Opened" stroke="var(--ge-accent)" strokeWidth={1.5} fill="url(#ge-opened)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
